seq       = require('bionode-seq')
Nt        = require('ntseq')

helper    = require('../helper')
Arrow     = require('./arrow')
Feature   = require('./feature')
Select    = require('./select')

Pablo     = window.Pablo
Raphael   = window.Raphael
jQuery    = require('jquery');
$         = jQuery;

fs = require('fs');

###
todo order features after probility
###

plasmidId=1

class Plasmid

  constructor: (dna,data, features) ->

    window.activePlasmid = this
    
    @id      = plasmidId
    plasmidId++
    @scale    = 1 
    @browser  = false

    @ob       = null  #drawing object
    @obCopy      = $("<textarea/>").appendTo("body")  #copy helper
    #hide helper object
    @obCopy.css 
      position:"absolute"
      top:"-100px"
      left:"-100px"
      
      
    ###   
  
    @df = new Array()
    ###
    @df=[{"name":"AmpR (3)","typ":"feature","bp":"ATGAGTATTCAACATTTCCGTGTCGCCCTTATTCCCTTTTTTGCGGCATTTTGCCTTCCTGTTTTTGCTCACCCAGAAACGCTGGTGAAAGTAAAAGATGCTGAAGATCAGTTGGGTGCACGAGTGGGTTACATCGAACTGGATCTCAACAGCGGTAAGATCCTTGAGAGTTTTCGCCCCGAAGAACGTTTTCCAATGATGAGCACTTTTAAAGTTCTGCTATGTGGCGCGGTATTATCCCGTGTTGACGCCGGGCAAGAGCAACTCGGTCGCCGCATACACTATTCTCAGAATGACTTGGTTGAGTACTCACCAGTCACAGAAAAGCATCTTACGGATGGCATGACAGTAAGAGAATTATGCAGTGCTGCCATAACCATGAGTGATAACACTGCGGCCAACTTACTTCTGACAACGATCGGAGGACCGAAGGAGCTAACCGCTTTTTTGCACAACATGGGGGATCATGTAACTCGCCTTGATCGTTGGGAACCGGAGCTGAATGAAGCCATACCAAACGACGAGCGTGACACCACGATGCCTGCAGCAATGGCAACAACGTTGCGCAAACTATTAACTGGCGAACTACTTACTCTAGCTTCCCGGCAACAATTAATAGACTGGATGGAGGCGGATAAAGTTGCAGGACCACTTCTGCGCTCGGCCCTTCCGGCTGGCTGGTTTATTGCTGATAAATCTGGAGCCGGTGAGCGTGGGTCTCGCGGTATCATTGCAGCACTGGGGCCAGATGGTAAGCCCTCCCGTATCGTAGTTATCTACACGACGGGGAGTCAGGCAACTATGGATGAACGAAATAGACAGATCGCTGAGATAGGTGCCTCACTGATTAAGCATTGGTAA"},{"name":"CAP binding site","typ":"feature","bp":"TAATGTGAGTTAGCTCACTCAT"},{"name":"KanR","typ":"feature","bp":"ATGGCAATTACCTTATCCGCAACTTCTTTACCTATTTCCGCCCGGATCCGGGCAGGTTCTCCGGCCGCTTGGGTGGAGAGGCTATTCGGCTATGACTGGGCACAACAGACAATCGGCTGCTCTGATGCCGCCGTGTTCCGGCTGTCAGCGCAGGGGCGCCCGGTTCTTTTTGTCAAGACCGACCTGTCCGGTGCCCTGAATGAACTGCAGGACGAGGCAGCGCGGCTATCGTGGCTGGCCACGACGGGCGTTCCTTGCGCAGCTGTGCTCGACGTTGTCACTGAAGCGGGAAGGGACTGGCTGCTATTGGGCGAAGTGCCGGGGCAGGATCTCCTGTCATCTCACCTTGCTCCTGCCGAGAAAGTATCCATCATGGCTGATGCAATGCGGCGGCTGCATACGCTTGATCCGGCTACCTGCCCATTCGACCACCAAGCGAAACATCGCATCGAGCGAGCACGTACTCGGATGGAAGCCGGTCTTGTCGATCAGGATGATCTGGACGAAGAGCATCAGGGGCTCGCGCCAGCCGAACTGTTCGCCAGGCTCAAGGCGCGCATGCCCGACGGCGAGGATCTCGTCGTGACCCATGGCGATGCCTGCTTGCCGAATATCATGGTGGAAAATGGCCGCTTTTCTGGATTCATCGACTGTGGCCGGCTGGGTGTGGCGGACCGCTATCAGGACATAGCGTTGGCTACCCGTGATATTGCTGAAGAGCTTGGCGGCGAATGGGCTGACCGCTTCCTCGTGCTTTACGGTATCGCCGCTCCCGATTCGCAGCGCATCGCCTTCTATCGCCTTCTTGACGAGTTCTTCTGA"},{"name":"M13 fwd","typ":"feature","bp":"GTAAAACGACGGCCAGT"},{"name":"SV40 ori","typ":"feature","bp":"ATCCCGCCCCTAACTCCGCCCAGTTCCGCCCATTCTCCGCCCCATGGCTGACTAATTTTTTTTATTTATGCAGAGGCCGAGGCCGCCTCGGCCTCTGAGCTATTCCAGAAGTAGTGAGGAGGCTTTTTTGGAGGCC"},{"name":"T7 promoter","typ":"feature","bp":"TAATACGACTCACTATAGG"},{"name":"M13 rev","typ":"feature","bp":"CAGGAAACAGCTATGAC"},{"name":"SV40 poly(A) signal (2)","typ":"feature","bp":"AACTTGTTTATTGCAGCTTATAATGGTTACAAATAAAGCAATAGCATCACAAATTTCACAAATAAAGCATTTTTTTCACTGCATTCTAGTTGTGGTTTGTCCAAACTCATCAATGTATCTTATCATGTCTGGATC"},{"name":"T3 promoter","typ":"feature","bp":"AATTAACCCTCACTAAAGG"},{"name":"lac UV5 promoter","typ":"feature","bp":"TTTACACTTTATGCTTCCGGCTCGTATAATG"},{"name":"lac operator (2)","typ":"feature","bp":"GGAATTGTGAGCGGATAACAATTCC"},{"name":"ori","typ":"feature","bp":"TTGAGATCCTTTTTTTCTGCGCGTAATCTGCTGCTTGCAAACAAAAAAACCACCGCTACCAGCGGTGGTTTGTTTGCCGGATCAAGAGCTACCAACTCTTTTTCCGAAGGTAACTGGCTTCAGCAGAGCGCAGATACCAAATACTGTCCTTCTAGTGTAGCCGTAGTTAGGCCACCACTTCAAGAACTCTGTAGCACCGCCTACATACCTCGCTCTGCTAATCCTGTTACCAGTGGCTGCTGCCAGTGGCGATAAGTCGTGTCTTACCGGGTTGGACTCAAGACGATAGTTACCGGATAAGGCGCAGCGGTCGGGCTGAACGGGGGGTTCGTGCACACAGCCCAGCTTGGAGCGAACGACCTACACCGAACTGAGATACCTACAGCGTGAGCTATGAGAAAGCGCCACGCTTCCCGAAGGGAGAAAGGCGGACAGGTATCCGGTAAGCGGCAGGGTCGGAACAGGAGAGCGCACGAGGGAGCTTCCAGGGGGAAACGCCTGGTATCTTTATAGTCCTGTCGGGTTTCGCCACCTCTGACTTGAGCGTCGATTTTTGTGATGCTCGTCAGGGGGGCGGAGCCTATGGAAA"},{"name":"AmpR promoter (2)","typ":"feature","bp":"CGCGGAACCCCTATTTGTTTATTTTTCTAAATACATTCAAATATGTATCCGCTCATGAGACAATAACCCTGATAAATGCTTCAATAATATTGAAAAAGGAAGAGT"},{"name":"M13 ori (3)","typ":"feature","bp":"ACGCGCCCTGTAGCGGCGCATTAAGCGCGGCGGGTGTGGTGGTTACGCGCAGCGTGACCGCTACACTTGCCAGCGCCCTAGCGCCCGCTCCTTTCGCTTTCTTCCCTTCCTTTCTCGCCACGTTCGCCGGCTTTCCCCGTCAAGCTCTAAATCGGGGGCTCCCTTTAGGGTTCCGATTTAGTGCTTTACGGCACCTCGACCCCAAAAAACTTGATTTGGGTGATGGTTCACGTAGTGGGCCATCGCCCTGATAGACGGTTTTTCGCCCTTTGACGTTGGAGTCCACGTTCTTTAATAGTGGACTCTTGTTCCAAACTGGAACAACACTCAACCCTATCTCGGGCTATTCTTTTGATTTATAAGGGATTTTGCCGATTTCGG"}]
    @features    = []     #detected features 
    @history    = []    #cloning steps
    @name      = "Untiled"  #set default name
    @author      = ""    #author of plasmid
    @description  = ""    #description of plasmid
    @displayOptions = 
      editable: false #edit dna
      features: true  #show features
      cutters: false  #show restriction enzymes
      primers: false  #show primers
      linear: false   #display as vector or linear dna
    
    @size    = [1500,1500]
    @center    = [750,750]
    @radius     = 250
    
    @layers    = []

    @typ = seq.checkType(dna) #check if it's dna

    #todo move to file
    @restrictionEnzyms = [
      ["EcoRI","GAATTC",0,0]  
      ["XhoI","CTCGAG",0,0]  
      ["XbaI","TCTAGA",0,0]  

    ]  
    
    @commonFeatures = features

    @cutters  =  {}

    for index,value of data
      this[index]=value
      
    #todo find out why replace??
    @bp     = dna.replace(/[^atcgATCG]/g,'')
    @rbp    = seq.complement(dna)
    @length = @bp.length

    @frames = seq.getAllOpenReadingFrames(@bp)

    @findCutters()
    @findFeatures()


  writeFeatures: () ->
  
    content = ">Vektor\n"+@bp+"\n"

    for feature in @df
      content+= ">"+feature.name+"\n"+feature.bp+"\n"

    fs.writeFile('fasta.txt', content, (err) ->
      console.log('wrote > fasta.txt');
    );
  findCutters: () ->

    for enzyme in @restrictionEnzyms
      indexes=helper.getIndicesOf(@bp,enzyme[1],false)
      @cutters[enzyme[0]]=indexes if indexes

  alignDNA: (dna,feature,direction) ->
    add=0
    if direction 
      query=seq.reverse(feature[1])
    else
      query = feature[1];
    
    while dna.length>query.length

      target = dna;
      isLocal = true;
      match = 1;
      mis = -1
      gapOpen = -1
      gapExt = -1
      rst = bsa_align(isLocal, target, query, [match,mis], [gapOpen,gapExt]);
      
      #console.log Math.round((rst[0]/query.length)*100),feature[0],rst
      if (rst[0]/query.length)*100 > 90
        @features.push [feature[0],add+rst[1],rst[2]-rst[1],direction]

      dna=dna.slice(rst[2])
      add=rst[2]
      break unless rst[2]
      
  alignDNAFast: (dna,querySeq,feature,direction) ->

    return [] if dna.size() < querySeq.size()
    f=[]
    map = new Nt.MatchMap(querySeq, dna)
    result=map.best()
    if result.matches/feature.bp.length>=0.95
      return [[feature.name,result.position,result.matches,direction]]
      ###
      results=map.top()
      for i in [1...results.length-1]
        result=results[i]
        break if result.matches/feature.bp.length<0.95
        f.push [feature.name,result.position,result.matches,direction]
      ###

    ###
    results=map.top()
    for result in results

      break if result.matches/feature.bp.length<0.95
      f.push [feature.name,result.position,result.matches,direction]
    ###
  

    return f

  
  detectFeature: (bp,offset,i) ->

    return if i>= @commonFeatures.length
    feature = @commonFeatures[i]

    dna = new Nt.Seq();
    dna.read(bp);

    querySeq = new Nt.Seq();
    querySeq.read(feature.bp);  

    

    matchesNom   = @alignDNAFast(dna,querySeq,feature,0)
    matchesRev  = @alignDNAFast(dna,querySeq.complement(),feature,1) 


    matches=[]

    for m in matchesNom
      matches.push m

    for m in matchesRev
      matches.push m


    if matches.length

      #test loop
      matches=matches.sort((a,b)->
        return a[1]-b[1]
      )
      beforeMatch =0
      
      for i in [0..matches.length-1] #todo order for loop
        
        afterMatch =-1

        match=matches[i]
        beforeMatch=matches[i-1][1]+matches[i-1][2] if i>0
        afterMatch =matches[i+1][1] if i<matches.length-1        

        before  = bp.slice(beforeMatch,match[1])
        after  = bp.slice(match[1]+match[2],afterMatch)

        @df.push feature
        @features.push [feature.name,match[1]+offset,match[2],match[3]]

        @detectFeature(before,offset,i+1)
        @detectFeature(after,offset+match[1]+match[2],i+1)

    else
      @detectFeature(bp,offset,i+1)
  




  findFeatures: () ->


    time_start = new Date().getTime();    

    @commonFeatures=@df.concat(@commonFeatures) #todo screen arrays for common features
    @detectFeature(@bp,0,0)


    elapse = (new Date().getTime() - time_start) / 1000.0;
    console.log "findFeatures", elapse.toFixed(3) + "s"

  drawSVG: (paper) ->


    l=@length
    cutters=@cutters  
    circle = paper.circle(@center[0], @center[1], @radius-4);
    circle.attr({"stroke":"#000","stroke-width":2});

    circle = paper.circle(@center[0], @center[1], @radius);
    circle.attr({"stroke":"#000","stroke-width":2});

    #draw plasmid name
    text = paper.text(@center[0], @center[1]-10, @name);
    text.attr({ "font-size": 20, "font-family": "Times New Roman,Georgia,Serif", "font-weight": "bold", "font-style": "normal"});
    

    #draw plasmid bp length
    text = paper.text(@center[0], @center[1]+10, @length+"bp");
    text.attr({ "font-size": 16, "font-family": "Times New Roman,Georgia,Serif", "font-style": "normal"});
    

    if @displayOptions.features
      for feature in @features
                
        text = feature[0]               
                
                
        arrow=new Arrow(
          center:  @center
          radius:  @radius-40
          text:  text
          plasmid: this
        )
        #todo calculate endAngle corrrect
        
        #orientation
        if feature[3]
          arrow.endAngle    =  (feature[1]/l)*360;
          arrow.startAngle  =  ((feature[1]+feature[2])/l)*360;  
        else  
          arrow.startAngle  =  (feature[1]/l)*360;
          arrow.endAngle    =  ((feature[1]+feature[2])/l)*360;  

        arrow.draw(paper)

    if @browser
      @selecter=new Select(
        center:  @center
        radius:  @radius-2
        text:  ""
        startAngle: 10
        endAngle:  50
        fillColor: "rgb(100,100,100)"
        borderColor: "rgb(100,100,100)"
        opacity: 0.3
        class: "select"
        plasmid: this  
      )
      @selecter.draw(paper)

    #draw enzym cutters
    if @displayOptions.cutters
      for name,positions of cutters

        for index,pos of positions

          angle=(pos/l)*360;

          start   = helper.calculateCircle(@center,@radius,angle)
          end    = helper.calculateCircle(@center,@radius+30,angle)      
        

          line=paper.path("M"+start[0]+" "+start[1]+"L"+end[0]+" "+end[1]+"L"+(end[0]+100)+" "+end[1]);  
          line.attr({"stroke":"#000","stroke-width":1})


          text = paper.text(end[0]+105, end[1]-2, name);
          text.attr({ "font-size": 20, "text-anchor":"left","font-family": "Courier New", "font-style": "normal","style":""});
          text.node.style=""

    lmax=Math.floor(l/1000)

    for i in [0..lmax]
      angle=(i/(l/1000))*360;

      start   = helper.calculateCircle(@center,@radius-5,angle)
      end    = helper.calculateCircle(@center,@radius-10,angle)      
      

      line=paper.path("M"+start[0]+" "+start[1]+"L"+end[0]+" "+end[1]);  
      line.attr({"stroke":"#000","stroke-width":2})

      r=@radius
      if angle>90 && angle<270
        start   = helper.calculateCircle(@center,r-8,angle+9)
        middle  = helper.calculateCircle(@center,r-8,angle+1)
        fix=0

      else  
        start   = helper.calculateCircle(@center,r-17,angle+1)
        middle  = helper.calculateCircle(@center,r-17,angle+9)
        fix=1
 

      d = [
            "M", start[0], start[1], 
            "A", r, r, 0, 0,fix, middle[0], middle[1]

        ].join(" ");

      circle=paper.path(d);  
      circle.attr({"stroke":"#000","stroke-width":0})
      pathId="plasmid+"+@id+"bp"+i
      circle.node.id=pathId


      text = paper.text(5, 0, i*1000);
      text.attr({ "font-size": 12,"text-anchor":"left", "font-family": "Courier New", "font-style": "normal","textpath":pathId});
      text.node.style=""

  draw: (id) ->
  
    console.log "draw", id
    self=this

    @width  =  @size[0]
    @height  =  @size[1]  
    paper  =  Raphael(id,@width,@height);

    @ob    =  $("#"+id)
    @svgOb = @ob.find("svg:first")

    #@svgOb=@ob.find("svg").svg("get")  

    @svg=self.drawSVG(paper)
      
    realWidth = (@radius+20*@layers.length-30)*2 
    @ob.css
      #width: (realWidth)+'px'
      #height: (realWidth)+'px'
      position:"relative"    
      "transform": "scale("+@scale+")"
      "transform-origin":"top left"  
      
    ###  
    if typeof window.Pablo == "function"
      pabloNode = window.Pablo($("svg")[0])  
      bbox = pabloNode.bbox();


      border      = {x:10, y:10}
      textPadding = 200

      bbox.width  = bbox.width + border.x
      bbox.height = bbox.height + border.x

      if @radius*2+textPadding >  bbox.width 
         bbox.x      = bbox.x - (@radius*2+textPadding-bbox.width)/2
         bbox.width  = @radius*2+textPadding
      else
        bbox.x      = bbox.x - border.x/2

      if @radius*2+textPadding >  bbox.height 
        bbox.y      = bbox.y - (@radius*2+textPadding-bbox.height)/2
        bbox.height  = @radius*2+textPadding
      else
        bbox.y      = bbox.y - border.y/2     

      @crop = bbox

      pabloNode.cropSize(bbox);

      @size   = [@crop.width,@crop.height]
      @center = [@center[0]-@crop.x,@center[1]-@crop.y]
    
      @addEvents()  
      console.log "crop", @crop, @size, @center
    ###  
    @ob.find("svg").css
      #left: ((realWidth-@size[0])/2)+'px'
      #top: ((realWidth-@size[0])/2)+'px'
      position: "relative"
      float: "left"
      
    return @ob.find("svg")[0].outerHTML
  getSVG: () ->

    @draw()


    #return @svg.replace(new RegExp('textpath', 'g'), 'textPath');    

  selectAll: () ->

    @showStart({angle:0,bp:0})    
    @selectEnd({angle:359.99,bp:@bp.length})

  copySequence: () ->
    try 
      value=@bp.slice(@selectingStartData.bp,@selectingEndData.bp)
      @obCopy.text(value).select()
      document.execCommand('copy');
    catch err
      console.log('Oops, unable to copy');

  addEvents: () ->



    plasmid=this
    @selecter.hide()

    Mousetrap.bind('command+a', (e) ->
       window.activePlasmid.selectAll() if window.activePlasmid
       return false
    )
    Mousetrap.bind('command+c', (e) ->
       window.activePlasmid.copySequence() if window.activePlasmid
       return false
    )
    document.onselectstart=() ->
      return false if window.activePlasmid.selecting

    $(window).mousedown((e)->
      1#window.activePlasmid.deselect() if window.activePlasmid.hover
    )
    
    @ob.mousedown((e)->
      window.activePlasmid.deselect() if window.activePlasmid

      window.activePlasmid=plasmid
      data=plasmid.calculateClick(this,e)
      plasmid.selectStart(data)    

    ).mousemove((e)->
      #window.activePlasmid.deselect() if window.activePlasmid && window.activePlasmid!=plasmid
      window.activePlasmid=plasmid

      data=plasmid.calculateClick(this,e)
      plasmid.selectMove(data)
    ).mouseup((e)->
      #window.activePlasmid.deselect()  if window.activePlasmid && window.activePlasmid!=plasmid

      window.activePlasmid=plasmid

      data=plasmid.calculateClick(this,e)
      plasmid.selectEnd(data)
    )  
  calculateClick: (self,e) ->
    parentOffset = @ob.offset(); 
    relX = e.pageX - parentOffset.left;
    relY = e.pageY - parentOffset.top;
    cutX=@center[0]*@scale
    cutY=@center[1]*@scale #@ob.height()/2#
    #console.log(parentOffset, relX, relY, cutX, cutY)
    x=(relX-cutX)
    y=(relY-cutY)
    angle   =360-(Math.atan2(x,y)*180/Math.PI+180)
    bp    =Math.round(@bp.length*(angle/360))  
    distance=Math.sqrt(x*x+y*y)
    data = 
      angle:angle
      bp:bp
      distance:distance
    #console.log("calculateClick", data)
    return data 

  deselect: () ->
    @selecter.hide()  
      
  selectStart: (data) ->
    if data.distance >(@radius-20)*@scale && data.distance <(@radius+20)*@scale
      @showStart(data)
    else
      @selecter.hide()  

  showStart: (data) ->
    angle=data.angle
    @selecting=1
    @startedSelecting=1
    @selectingStartData= data
    @selectingEndData  = data

    @selecter.startAngle     = angle
    @selecter.endAngle   = angle+0.1
    @selecter.updatePath(@selectingStartData.bp,@selectingEndData.bp)

    @selecter.show()    
  selectMove: (data) ->

    angle=data.angle
    if @selecting
      @selectingEndData=data

      @selecter.startAngle= @selectingStartData.angle
      @selecter.endAngle   = @selectingEndData.angle
      @selecter.endAngle+=0.1 if @selecter.startAngle==@selecter.endAngle

      @selecter.updatePath(@selectingStartData.bp,@selectingEndData.bp)

  selectEnd: (data) ->
  
    if @selecting
      angle=data.angle
      @selectMove(data)
      @selecting =0
    
  getLayer: (startAngle, endAngle, t) ->
  
    #340, 380  - 10, 30
    #console.log t, startAngle, endAngle
    nope = 1
    for index, layer of @layers 
      #console.log "layer",index, layer
      if nope==0 
        @layers[index-1] = [] unless @layers[index-1] 
        @layers[index-1].push [startAngle,endAngle]    
        @layers[index-1].push [0,endAngle%360]  if endAngle > 360
        return index-1
      nope = 0    
      for text in layer
        #console.log "layer"+index, t,startAngle<endAngle, startAngle, endAngle, text[0], text[1],  !((startAngle<text[0] && endAngle<text[0]) || (startAngle>text[1] && endAngle>text[1]))
        #console.log "#",endAngle%360,"<",text[0]
        if !((startAngle<text[0] && endAngle<text[0]) || (startAngle>text[1] && endAngle>text[1])) ||  (endAngle>360 && endAngle%360>text[0]) 
            nope = 1
            break
          
          
    n = if nope then @layers.length else @layers.length-1
    @layers[n] = [] unless @layers[n]
    @layers[n].push [startAngle,endAngle]
    @layers[index-1].push [0,endAngle%360]  if endAngle > 360
    
    return n
          
  getRadius: (startAngle, endAngle, text) ->    
    n = @getLayer(startAngle, endAngle, text)
    #console.log("layer", n)
    if n == 0
      return @radius-80
    else
      return @radius-10+20*n
    
  getPNG: () ->
    saveSvgAsPng(@ob.find("svg")[0],@name+".png")

    
module.exports=Plasmid


